import { Component, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { ToastrService } from 'ngx-toastr'
import { UserService } from 'src/app/services/user.service'
import { ValidarCpf } from '../../helpers/validate-cpf'

@Component({
  selector: 'app-dados-bancarios',
  templateUrl: './dados-bancarios.component.html',
  styleUrls: ['./dados-bancarios.component.scss']
})
export class DadosBancariosComponent implements OnInit {

	bancario = {
		bankCode: null,
		agencia: null,
		agenciaDv: null,
		conta: null,
		contaDv: null,
		legalName: null,
		document: null,
	}

	confirmTitle = 'Confirma atualizar conta bancária?'
	confirmMsg = 'Ao atualizar seus dados bancários, seu histórico de transações da conta atual serão perdidas!'
	openModalConfirmation = false

  bancarioForm = new FormGroup({
		bankCode: new FormControl(this.bancario.bankCode),
		agencia: new FormControl(this.bancario.agencia),
		agenciaDv: new FormControl(this.bancario.agenciaDv),
		conta: new FormControl(this.bancario.conta),
		contaDv: new FormControl(this.bancario.contaDv),
		legalName: new FormControl(this.bancario.legalName),
		document: new FormControl(this.bancario.document),
	})

  constructor (
    private userService: UserService,
    private toastr: ToastrService
  ) { }
  loading = true
	updating = false

  bankCodes = [
		{ code: '001', value: 'Banco do Brasil S.A.'},
		{ code: '260', value: 'Nubank' },
		{ code: '077', value: 'Banco Inter' },
		{ code: '735', value: 'Neon' },
		{ code: '121', value: 'Agibank' },
		{ code: '136', value: 'Unicred' },
		{ code: '336', value: 'C6 Bank' },
		{ code: '290', value: 'PagBank' },
		{ code: '237', value: 'Next' },
		{ code: '212', value: 'Banco Original' },
		{ code: '323', value: 'Mercado Pago' },
		{ code: '290', value: 'Pagseguro' },
		{ code: '033', value: 'Banco Santander (Brasil) S.A.'},
		{ code: '104', value: 'Caixa Econômica Federal'},
		{ code: '237', value: 'Banco Bradesco S.A.'},
		{ code: '341', value: 'Banco Itaú S.A.'},
		{ code: '356', value: 'Banco Real S.A. (antigo)'},
		{ code: '389', value: 'Banco Mercantil do Brasil S.A.'},
		{ code: '399', value: 'HSBC Bank Brasil S.A. - Banco Múltiplo'},
		{ code: '422', value: 'Banco Safra S.A.'},
		{ code: '453', value: 'Banco Rural S.A.'},
		{ code: '633', value: 'Banco Rendimento S.A.'},
		{ code: '652', value: 'Itaú Unibanco Holding S.A.'},
		{ code: '745', value: 'Banco Citibank S.A.'},
		{ code: '246', value: 'Banco ABC Brasil S.A.'},
		{ code: '025', value: 'Banco Alfa S.A.'},
		{ code: '641', value: 'Banco Alvorada S.A.'},
		{ code: '029', value: 'Banco Banerj S.A.'},
		{ code: '038', value: 'Banco Banestado S.A.'},
		{ code: '000', value: 'Banco Bankpar S.A.'},
		{ code: '740', value: 'Banco Barclays S.A.'},
		{ code: '107', value: 'Banco BBM S.A.'},
		{ code: '031', value: 'Banco Beg S.A.'},
		{ code: '096', value: 'Banco BM&F de Serviços de Liquidação e Custódia S.A'},
		{ code: '318', value: 'Banco BMG S.A.'},
		{ code: '752', value: 'Banco BNP Paribas Brasil S.A.'},
		{ code: '248', value: 'Banco Boavista Interatlântico S.A.'},
		{ code: '036', value: 'Banco Bradesco BBI S.A.'},
		{ code: '204', value: 'Banco Bradesco Cartões S.A.'},
		{ code: '225', value: 'Banco Brascan S.A.'},
		{ code: '044', value: 'Banco BVA S.A.'},
		{ code: '263', value: 'Banco Cacique S.A.'},
		{ code: '473', value: 'Banco Caixa Geral - Brasil S.A.'},
		{ code: '222', value: 'Banco Calyon Brasil S.A.'},
		{ code: '040', value: 'Banco Cargill S.A.'},
		{ code: 'M08', value: 'Banco Citicard S.A.'},
		{ code: 'M19', value: 'Banco CNH Capital S.A.'},
		{ code: '215', value: 'Banco Comercial e de Investimento Sudameris S.A.'},
		{ code: '756', value: 'Banco Cooperativo do Brasil S.A. - BANCOOB'},
		{ code: '748', value: 'Banco Cooperativo Sicredi S.A.'},
		{ code: '505', value: 'Banco Credit Suisse (Brasil) S.A.'},
		{ code: '229', value: 'Banco Cruzeiro do Sul S.A.'},
		{ code: '003', value: 'Banco da Amazônia S.A.'},
		{ code: '083', value: '– Banco da China Brasil S.A.'},
		{ code: '707', value: 'Banco Daycoval S.A.'},
		{ code: 'M06', value: 'Banco de Lage Landen Brasil S.A.'},
		{ code: '024', value: 'Banco de Pernambuco S.A. – BANDEPE'},
		{ code: '456', value: 'Banco de Tokyo-Mitsubishi UFJ Brasil S.A.'},
		{ code: '214', value: 'Banco Dibens S.A.'},
		{ code: '047', value: 'Banco do Estado de Sergipe S.A.'},
		{ code: '037', value: 'Banco do Estado do Pará S.A.'},
		{ code: '041', value: 'Banco do Estado do Rio Grande do Sul S.A.'},
		{ code: '004', value: 'Banco do Nordeste do Brasil S.A.'},
		{ code: '265', value: 'Banco Fator S.A.'},
		{ code: 'M03', value: 'Banco Fiat S.A.'},
		{ code: '224', value: 'Banco Fibra S.A.'},
		{ code: '626', value: 'Banco Ficsa S.A.'},
		{ code: '394', value: 'Banco Finasa BMC S.A.'},
		{ code: 'M18', value: 'Banco Ford S.A.'},
		{ code: '233', value: 'Banco GE Capital S.A.'},
		{ code: '734', value: 'Banco Gerdau S.A.'},
		{ code: 'M07', value: 'Banco GMAC S.A.'},
		{ code: '612', value: 'Banco Guanabara S.A.'},
		{ code: 'M22', value: 'Banco Honda S.A.'},
		{ code: '063', value: 'Banco Ibi S.A. Banco Múltiplo'},
		{ code: 'M11', value: 'Banco IBM S.A.'},
		{ code: '604', value: 'Banco Industrial do Brasil S.A.'},
		{ code: '320', value: 'Banco Industrial e Comercial S.A.'},
		{ code: '653', value: 'Banco Indusval S.A.'},
		{ code: '630', value: 'Banco Intercap S.A.'},
		{ code: '249', value: 'Banco Investcred Unibanco S.A.'},
		{ code: '184', value: 'Banco Itaú BBA S.A.'},
		{ code: '479', value: 'Banco ItaúBank S.A'},
		{ code: 'M09', value: 'Banco Itaucred Financiamentos S.A.'},
		{ code: '376', value: 'Banco J. P. Morgan S.A.'},
		{ code: '074', value: 'Banco J. Safra S.A.'},
		{ code: '217', value: 'Banco John Deere S.A.'},
		{ code: '065', value: 'Banco Lemon S.A.'},
		{ code: '600', value: 'Banco Luso Brasileiro S.A.'},
		{ code: '755', value: 'Banco Merrill Lynch de Investimentos S.A.'},
		{ code: '746', value: 'Banco Modal S.A.'},
		{ code: '151', value: 'Banco Nossa Caixa S.A.'},
		{ code: '045', value: 'Banco Opportunity S.A.'},
		{ code: '623', value: 'Banco Panamericano S.A.'},
		{ code: '611', value: 'Banco Paulista S.A.'},
		{ code: '643', value: 'Banco Pine S.A.'},
		{ code: '638', value: 'Banco Prosper S.A.'},
		{ code: '747', value: 'Banco Rabobank International Brasil S.A.'},
		{ code: 'M16', value: 'Banco Rodobens S.A.'},
		{ code: '072', value: 'Banco Rural Mais S.A.'},
		{ code: '250', value: 'Banco Schahin S.A.'},
		{ code: '749', value: 'Banco Simples S.A.'},
		{ code: '366', value: 'Banco Société Générale Brasil S.A.'},
		{ code: '637', value: 'Banco Sofisa S.A.'},
		{ code: '464', value: 'Banco Sumitomo Mitsui Brasileiro S.A.'},
		{ code: '082', value: 'Banco Topázio S.A.'},
		{ code: 'M20', value: 'Banco Toyota do Brasil S.A.'},
		{ code: '634', value: 'Banco Triângulo S.A.'},
		{ code: '208', value: 'Banco UBS Pactual S.A.'},
		{ code: 'M14', value: 'Banco Volkswagen S.A.'},
		{ code: '655', value: 'Banco Votorantim S.A.'},
		{ code: '610', value: 'Banco VR S.A.'},
		{ code: '370', value: 'Banco WestLB do Brasil S.A.'},
		{ code: '021', value: 'BANESTES S.A. Banco do Estado do Espírito Santo'},
		{ code: '719', value: 'Banif-Banco Internacional do Funchal (Brasil)S.A.'},
		{ code: '073', value: 'BB Banco Popular do Brasil S.A.'},
		{ code: '078', value: 'BES Investimento do Brasil S.A.-Banco de Investimento'},
		{ code: '069', value: 'BPN Brasil Banco Múltiplo S.A.'},
		{ code: '070', value: 'BRB – Banco de Brasília S.A.'},
		{ code: '477', value: 'Citibank N.A.'},
		{ code: '081', value: '– Concórdia Banco S.A.'},
		{ code: '487', value: 'Deutsche Bank S.A. – Banco Alemão'},
		{ code: '751', value: 'Dresdner Bank Brasil S.A. – Banco Múltiplo'},
		{ code: '062', value: 'Hipercard Banco Múltiplo S.A.'},
		{ code: '492', value: 'ING Bank N.V.'},
		{ code: '488', value: 'JPMorgan Chase Bank'},
		{ code: '409', value: 'UNIBANCO – União de Bancos Brasileiros S.A.'},
		{ code: '230', value: 'Unicard Banco Múltiplo S.A.'},
		{ code: '403', value: 'Cora Sociedade de Crédito Direto S/A'}
  ]

  ngOnInit () {
    this.getAccountUser()
  }

	getAccountUser () {
		this.userService.getPerfil().subscribe(
			(res) => {
        this.bancario = res['bancario']
        this.loading = false
			},
			(err) => {
        console.log(err)
      }
		)
	} 

  enviarBancario () {
		let bancario = this.bancarioForm.getRawValue()
		bancario["tipo"] = "conta_corrente"

		if (!bancario["agencia"]) {
			this.toastr.warning("A agência deve ser preenchida", "Atenção")
			return
		}

		if (!bancario["agenciaDv"]) {
			this.toastr.warning("O digito da agência deve ser preenchido", "Atenção")
			return
		}

		if (!bancario["bankCode"]) {
			this.toastr.warning("O banco da agência deve ser preenchido", "Atenção")
			return
		}

		if (!bancario["conta"]) {
			this.toastr.warning("A conta da agência deve ser preenchida", "Atenção")
			return
		}

		if (!bancario["contaDv"]) {
			this.toastr.warning("O digito da conta deve ser preenchido", "Atenção")
			return
		}

		if (!bancario["document"]) {
			this.toastr.warning("O documento deve ser preenchido", "Atenção")
			return
		} else if (!ValidarCpf.cpf(bancario["document"])) {
			this.toastr.warning("O documento é inválido", "Atenção")
			return
		}

		if (!bancario["legalName"]) {
			this.toastr.warning("O nome da conta deve ser preenchido", "Atenção")
			return
		}
    
		this.userService.setBancario(bancario).subscribe(
			(res) => {
				this.toastr.success("" + res, "Sucesso")
				this.getAccountUser()
				window.scrollTo(0, 0)
			},
			(err) => {
				if (err.status == 401) {
					this.toastr.error(err.error, "Erro")
				} else {
					console.log(err)
					this.toastr.error(
						"Erro no cadastro bancário. Valores incorretos",
						"Erro"
					)
				}
			}
		)
	}

	confirmUpdate (confirmation) {
		this.openModalConfirmation = true
		if (confirmation) {
			this.enviarBancarioUpdate()
		}
		
		if (confirmation === false) {
			this.openModalConfirmation = false
			confirmation = undefined
		}
	}

	enviarBancarioUpdate () {
		this.openModalConfirmation = false
		this.updating = true
		let bancario = this.bancarioForm.getRawValue()
		bancario["tipo"] = "conta_corrente"

		if (!bancario["agencia"]) {
			this.toastr.warning("A agência deve ser preenchida", "Atenção")
			return
		}

		if (!bancario["agenciaDv"]) {
			this.toastr.warning("O digito da agência deve ser preenchido", "Atenção")
			return
		}

		if (!bancario["bankCode"]) {
			this.toastr.warning("O banco da agência deve ser preenchido", "Atenção")
			return
		}

		if (!bancario["conta"]) {
			this.toastr.warning("A conta da agência deve ser preenchida", "Atenção")
			return
		}

		if (!bancario["contaDv"]) {
			this.toastr.warning("O digito da conta deve ser preenchido", "Atenção")
			return
		}

		if (!bancario["document"]) {
			this.toastr.warning("O documento deve ser preenchido", "Atenção")
			return
		} else if (!ValidarCpf.cpf(bancario["document"])) {
			this.toastr.warning("O documento é inválido", "Atenção")
			return
		}

		if (!bancario["legalName"]) {
			this.toastr.warning("O nome da conta deve ser preenchido", "Atenção")
			return
		}
    
		this.userService.updateBancario(bancario).subscribe(
			(res) => {
				this.updating = false
				this.toastr.success("" + res, "Sucesso")
				this.getAccountUser()
				window.scrollTo(0, 0)
			},
			(err) => {
				this.updating = false
				if (err.status == 401) {
					this.toastr.error(err.error, "Erro")
				} else {
					console.log(err)
					this.toastr.error(
						"Erro no cadastro bancário. Valores incorretos",
						"Erro"
					)
				}
			}
		)
	}

}
